import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { STUDY_ABROAD_SERVICES } from "@/lib/data";

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="py-24 md:py-32 relative bg-secondary/30 dark:bg-secondary/10">
      <div className="max-w-7xl mx-auto px-6 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <div className="text-xs tracking-[0.25em] uppercase text-[#D4AF37] font-bold mb-4">Our Services</div>
            <h2 className="text-4xl sm:text-5xl font-light tracking-tighter">
              Every step, <span className="font-serif italic text-gradient-royal">handled.</span>
            </h2>
          </div>
          <p className="text-muted-foreground max-w-md">
            From your first counselling call to your final boarding pass — a single-window experience for global success.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {STUDY_ABROAD_SERVICES.map((s, i) => {
            const Icon = Icons[s.icon] || Icons.Sparkles;
            return (
              <motion.div
                key={s.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.5, delay: i * 0.06 }}
                data-testid={`service-card-${i}`}
                className="group p-8 rounded-3xl bg-card border border-border hover:border-[#0F3D8C]/50 dark:hover:border-[#2563EB]/60 hover:-translate-y-1 transition-all duration-500 shadow-sm hover:shadow-xl"
              >
                <div className="flex items-start justify-between">
                  <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-[#0F3D8C] to-[#2563EB] flex items-center justify-center text-white shadow-lg">
                    <Icon className="w-7 h-7" strokeWidth={1.6} />
                  </div>
                  <div className="text-4xl font-light text-[#0F3D8C]/10 dark:text-white/10 font-serif">{String(i + 1).padStart(2, "0")}</div>
                </div>
                <h3 className="mt-6 font-heading font-semibold text-xl">{s.title}</h3>
                <p className="mt-3 text-sm text-muted-foreground leading-relaxed">{s.desc}</p>
                <div className="mt-6 pt-6 border-t border-border flex items-center gap-2 text-sm font-medium text-[#0F3D8C] dark:text-[#60A5FA] group-hover:gap-3 transition-all">
                  Learn more
                  <Icons.ArrowRight className="w-4 h-4" />
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
